import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import {
  instantTradeDialogVariantAtom,
  instantTradeDialogVisibleAtom,
} from '../atoms'

import { InstantTradeBottomDialog } from './instant-trade-bottom/instant-trade-bottom'
import { InstantTradeDialog } from './instant-trade-dialog'

import type { PairModel } from '@root/entities/pair'

type InstantTradeDialogsProps = {
  pair: PairModel
}

// TODO: Initialize models once here
export const InstantTradeDialogs: React.FC<InstantTradeDialogsProps> = ({
  pair,
}) => {
  const [isVisible] = useAtom(instantTradeDialogVisibleAtom)
  const [variant] = useAtom(instantTradeDialogVariantAtom)

  if (!isVisible) {
    return undefined
  }

  return (
    <>
      <AnimatePresence>
        {variant === 'floating' && <InstantTradeDialog pair={pair} />}
      </AnimatePresence>
      <AnimatePresence>
        {variant === 'bottom' && <InstantTradeBottomDialog pair={pair} />}
      </AnimatePresence>
    </>
  )
}
